/**
 * @generated SignedSource<<58e427b95a881eb0d1e149007bbefdf9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregation"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchFinish"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meterId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metric"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeZone"
},
v6 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "meterId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "aggregation",
    "variableName": "aggregation"
  },
  {
    "kind": "Variable",
    "name": "finish",
    "variableName": "batchFinish"
  },
  {
    "kind": "Variable",
    "name": "metric",
    "variableName": "metric"
  },
  {
    "kind": "Variable",
    "name": "start",
    "variableName": "batchStart"
  },
  {
    "kind": "Variable",
    "name": "timeZone",
    "variableName": "timeZone"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregation",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRange",
  "kind": "LinkedField",
  "name": "timeRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finish",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "Valid",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "dataBatchingMeterDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "CalculatedData",
            "kind": "LinkedField",
            "name": "calculatedData",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Metric",
                "kind": "LinkedField",
                "name": "metric",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CalculatedDatum",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flag",
                    "kind": "LinkedField",
                    "name": "flags",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataBatchingMeterDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "CalculatedData",
            "kind": "LinkedField",
            "name": "calculatedData",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Metric",
                "kind": "LinkedField",
                "name": "metric",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CalculatedDatum",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flag",
                    "kind": "LinkedField",
                    "name": "flags",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c121d84d3117bea7f555415b096b9602",
    "id": null,
    "metadata": {},
    "name": "dataBatchingMeterDataQuery",
    "operationKind": "query",
    "text": "query dataBatchingMeterDataQuery(\n  $meterId: ID!\n  $batchStart: Timestamp!\n  $batchFinish: Timestamp!\n  $aggregation: String!\n  $timeZone: String!\n  $metric: String!\n) {\n  meter(uuid: $meterId) {\n    uuid\n    calculatedData(start: $batchStart, finish: $batchFinish, aggregation: $aggregation, timeZone: $timeZone, metric: $metric) {\n      aggregation\n      metric {\n        identifier\n        id\n      }\n      timeZone\n      timeRange {\n        start\n        finish\n      }\n      data {\n        timestamp\n        value\n        flags {\n          identifier\n          description\n          Valid\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "0e552f7a4df97f1e4e9afb7c7ab48a69";

module.exports = node;
